<template>
  <div class="content">
    <div class="order-info">
      <div class="item">
        <div class="item-title">安装城市*</div>
        <div class="item-content">
          <span>{{order.city}}</span>
        </div>
      </div>
      <div class="item">
        <div class="item-title">教练车型*</div>
        <div class="item-content">
          <span>{{order.car_model}}</span>
        </div>
      </div>
      <div class="item">
        <div class="item-title">设备版本*</div>
        <div class="item-content">
          <span>{{+order.dev_version === 1 ? '中控版本' : '副驾驶版本'}}</span>
        </div>
      </div>
      <div class="item">
        <div class="item-title">预订数量*</div>
        <div class="item-content">
          <span>{{order.num}}</span>
        </div>
      </div>
      <div class="item">
        <div class="item-title">您的姓名</div>
        <div class="item-content">
          <span>{{order.receiver}}</span>
        </div>
      </div>
      <div class="item">
        <div class="item-title">联系方式*</div>
        <div class="item-content">
          <span>{{order.mobile}}</span>
        </div>
      </div>
      <div class="item">
        <div class="item-title">收货地址</div>
        <div class="item-content">
          <span>{{order.city}}市{{order.district}}{{order.address}}</span>
        </div>
      </div>
      <div class="item">
        <div class="item-title">备注</div>
        <div class="item-content">
          <span>{{order.remark}}</span>
        </div>
      </div>
    </div>
    <div class="order-pay">
      <div class="item">
        <div class="item-title">支付金额</div>
        <div class="item-content">
          <span>￥{{(599 * order.num).toFixed(2)}}</span>
        </div>
      </div>
      <div class="button" @click="flashSaleOrder">
        <button class="btn">立即支付</button>
      </div>
    </div>
    <div v-if="showDialog" class="dialog-item">
      <dialog-item :value="massage"></dialog-item>
    </div>
    <div v-if="showEmpty" class="dialog">
      <div class="main">
        <img class="dialog-img" src="http://picture.eclicks.cn/kaojiazhao/public/rem/dialog.png" alt="">
        <div class="hint">很抱歉，该城市已抢光</div>
        <div class="hint">您可以先提交预订意向</div>
        <button class="btn" @click="thinkPress" style="width: 5rem;">我想预定</button>
        <img src="/assets/images/close.png" alt="" class="close" @click="close">
      </div>
    </div>
    <div v-if="showDown" class="dialog">
      <div class="main">
        <img class="dialog-img" src="http://picture.eclicks.cn/kaojiazhao/public/rem/dialog.png" alt="">
        <div class="hint">很抱歉，当前城市库存仅剩{{balance}}台,请修改数量</div>
        <button class="btn" @click="close">知道了</button>
        <img src="/assets/images/close.png" alt="" class="close" @click="close">
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import dialogItem from '@/components/dialog'
import { flashSaleOrderMultiNum } from '@/http/api'
import { payUrl, hostUrl } from '../http/env.js'
import _wx from '../../static/js/chelun-wx-1.1.js'
export default {
  props: ['payOrder', 'openid'],
  data () {
    return {
      showDown: false,
      showEmpty: false,
      showDialog: false,
      massage: '',
      order: this.payOrder,
      isWx: _wx.isWx,
      os: '',
      balance: 0
    }
  },
  components: {
    'dialog-item': dialogItem
  },
  mounted () {
    console.log(this.order)
  },
  methods: {
    thinkPress () {
      this.close()
      window.location.href = 'https://www.wjx.top/jq/30024408.aspx'
    },
    close () {
      this.showDialog = false
      this.showDown = false
      this.showEmpty = false
    },
    showDia (massage) {
      this.showDialog = true
      this.massage = massage
      setTimeout(() => {
        this.showDialog = false
        this.massage = ''
      }, 1500)
    },
    flashSaleOrder () {
      let order = this.order
      flashSaleOrderMultiNum({
        receiver: order.receiver,
        mobile: order.mobile,
        city: order.city,
        city_id: order.city_id,
        district: order.district,
        address: order.address,
        dev_version: order.dev_version,
        pay_type: _wx.isWx ? 1 : 2,
        platform: 'wap',
        car_model: order.car_model,
        num: order.num,
        channel_no: 'WechatMoments',
        remark: order.remark
      }).then(res => {
        console.log(res)
        if (res.code === 0) {
          let data = res.data.data
          console.log(data)
          let pay = {
            amount: data.amount,
            bind_phone: data.bind_phone,
            channel: _wx.isWx ? 'weixin_mp' : 'alipay',
            id: data.id,
            order_no: data.order_no,
            serial_number: data.serial_number
          }
          this.pay(pay)
        } else if (res.code === 1006) {
          this.showDia(res.msg)
          this.balance = res.data.num
          if (this.balance > 0) {
            this.showDown = true
          } else {
            this.showEmpty = true
          }
        } else {
          console.log(res.msg)
          this.showDia(res.msg)
        }
      })
    },
    pay (pay) {
      let callbackUrl = `${hostUrl}/frontend/timelinepaid`
      let url = `${payUrl}/api.php?c=order&v=pay2&serial_number=${pay.serial_number}&channel=${pay.channel}&openid=${this.openid}&callback_url=${callbackUrl}`
      console.log(url)
      axios.get(url).then(res => {
        console.log(res)
        console.log(_wx.isWx)
        if (_wx.isWx) {
          _wx.pay(res.data.data.order_param, function () {
            console.log(res)
            window.location.href = res.data.data.order_param.callback_url
          })
        } else {
          window.location.href = res.data.data.url
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  color: #000;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #F4F5FC;
  .order-info {
    padding: 0 .3rem;
    box-sizing: border-box;
    background: #fff;
  }
  .item {
    border-bottom: 1px solid #eee;
    padding: .3rem 0;
    display: -webkit-flex;
    display: flex;
    align-items: center;
    .item-title {
      font-size: .3rem;
      width: 1.5rem;
      text-align: left;
    }
    .item-content {
      font-size: .26rem;
      flex: 1;
      text-align: right;
      span {
        display: inline-block;
        vertical-align: middle;
        color: rgba(51, 51, 51, 1);
        margin-right: .08rem;
      }
    }
  }
  .order-pay {
    padding: 0 .3rem;
    box-sizing: border-box;
    background: #fff;
    margin-top: .2rem;
  }
  .button {
    position: fixed;
    bottom: .2rem;
    left: 0;
    right: 0;
  }
  .btn {
    display: block;
    margin: auto;
    width: 7.10rem;
    height: .90rem;
    background: linear-gradient(32deg, rgba(235, 96, 50, 1), rgba(235, 74, 56, 1));
    border-radius: .12rem;
    font-size: .34rem;
    font-weight: 600;
    color: #FFFFFF;
    line-height: .90rem;
    text-align: center;
  }
}
.dialog {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9999;
  .main {
    width: 6rem;
    height: 6.17rem;
    background: rgba(255, 255, 255, 1);
    border-radius: .20rem;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    text-align: center;
    .dialog-img {
      width: 2.98rem;
      height: 1.45rem;
      margin: auto;
      margin-top: 1.06rem;
      margin-bottom: .66rem;
    }
    .hint {
      width: 5rem;
      font-size: .34rem;
      font-weight:600;
      color:rgba(0,0,0,1);
      margin: auto;
      text-align: center;
    }
    .btn {
      width: 5rem;
      height: .90rem;
      background: linear-gradient(32deg,rgba(235,96,50,1),rgba(235,74,56,1));
      border-radius: .12rem;
      font-size: .34rem;
      color: #fff;
      line-height: .9rem;
      font-weight: 500;
      margin-top: .6rem;
      display: inline-block;
      vertical-align: middle;
    }
    .close {
      position: absolute;
      right: .38rem;
      top: .38rem;
      width: .34rem;
      background: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/timeline.vue